import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import PropTypes from 'prop-types';

import ReportView from './ReportView';
import Loading from '../shared/Loading';
import { storeWithExpiration } from '../../utils/common';
import { getReport, getReportLink } from '../../actions/reports';

export class ReportViewContainer extends Component {
  static propTypes = {
    datasetId: PropTypes.string.isRequired,
    getReportAction: PropTypes.func.isRequired,
    getReportLinkAction: PropTypes.func.isRequired,
    report: PropTypes.object,
    reportName: PropTypes.string.isRequired,
    reportType: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
  };

  static defaultProps = {
    report: undefined,
  };

  componentWillMount = () => {
    const { datasetId, getReportAction, version, reportName, reportType } = this.props;
    const token = storeWithExpiration.get('token');
    getReportAction(parseInt(datasetId, 10), parseInt(version, 10), reportName, reportType, token);
  };

  getReportDownloadLink = () => {
    const { datasetId, getReportLinkAction, reportName, version } = this.props;
    const token = storeWithExpiration.get('token');
    getReportLinkAction(parseInt(datasetId, 10), parseInt(version, 10), reportName, token);
  };

  handleClickBack = e => {
    e && e.preventDefault();
    browserHistory.goBack();
  };

  render() {
    const { report, reportName } = this.props;
    const isLoaded = report !== undefined && report.size > 0;
    return isLoaded ? (
      <div className="container container-secondary">
        <div className="row row-top">
          <div className="col-xs-12 ">
            <span className="pull-right">
              <button
                className="btn btn-primary"
                onClick={() => {
                  this.getReportDownloadLink();
                }}
              >
                <i className="fa fa-cloud-download" /> Download
              </button>
            </span>
            <h1>
              <Link to="/" onClick={this.handleClickBack}>
                <i className="fa fa-angle-left" /> Data Reports
              </Link>
            </h1>
          </div>
        </div>
        <div className="single-info-page">
          <div className="single-info panel-active">
            <h4>{reportName}</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <ReportView report={report} />
          </div>
        </div>
      </div>
    ) : (
      <Loading />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { datasetId, version, reportName, reportType } = ownProps.params;
  const { reports } = state;
  const report = reports.get('report');
  return { datasetId, version, report, reportName, reportType };
};

export default connect(mapStateToProps, {
  getReportAction: getReport,
  getReportLinkAction: getReportLink,
})(ReportViewContainer);
